/** An agent's picture between a form and the API: what it has, and what saving a choice takes. */
import { api } from "../api/client.ts";
import type { Member, SpaceOut } from "../api/types.gen.ts";
import { orgApi } from "./paths.ts";
import { type AgentPicture, isPresetPicture } from "./pictures.ts";

/** An agent's picture as a form starts with it: the one it has. */
export function pictureOf(m: Pick<Member, "avatar">): AgentPicture {
  const a = m.avatar;
  if (a?.url) {
    return { kind: "current", url: a.url };
  }
  return isPresetPicture(a?.preset) ? { kind: "preset", preset: a.preset } : { kind: "none" };
}

/**
 * What adding or changing a member takes of the picture `choice`, given the one it `had`: one of the app's by key,
 * none (null), or nothing (no change, or an image to upload: `uploadChosen`).
 */
export function presetField(choice: AgentPicture, had: AgentPicture): { avatar_preset?: string | null } {
  if (choice.kind === "preset") {
    return had.kind === "preset" && had.preset === choice.preset ? {} : { avatar_preset: choice.preset };
  }
  return choice.kind === "none" && had.kind !== "none" ? { avatar_preset: null } : {};
}

/** Uploads the image chosen for member `id`, when the choice is one to upload. */
export async function uploadChosen(space: SpaceOut, id: string, choice: AgentPicture): Promise<void> {
  if (choice.kind === "upload") {
    await api.putFile(orgApi(space, `/members/${id}/avatar`), choice.blob);
  }
}
